import React from 'react';
import { useSelector } from 'react-redux';

const Article = ({ item }) => {
  return (
    <article class='col-lg-6 mb-50 animate-conner'>
      <div class='post-thumb d-flex mb-30 border-radius-5 img-hover-scale animate-conner-box'>
        <a
          href={`/${item.is_video_news === 1 ? 'tin-video' : 'tin-tuc'}/${
            item.slug
          }`}
        >
          <img src={item.thumbnail} alt='' />
        </a>
        {/* <span class='top-right-icon background8'>
          <i class='mdi mdi-flash-on'></i>
        </span> */}
        <ul class='social-share'>
          <li>
            <a href='#'>
              <i class='ti-sharethis'></i>
            </a>
          </li>
          <li>
            <a
              class='fb'
              href={`https://www.facebook.com/sharer/sharer.php?u=https://smedx.vn/${
                item.is_video_news === 1 ? 'tin-video' : 'tin-tuc'
              }/${item.slug}?utm_src=SMEdx`}
              title='Share on Facebook'
              target='_blank'
            >
              <i class='ti-facebook'></i>
            </a>
          </li>
          {/* <li>
            <a class='tw' href='#' target='_blank' title='Tweet now'>
              <i class='ti-twitter-alt'></i>
            </a>
          </li>
          <li>
            <a class='pt' href='#' target='_blank' title='Pin it'>
              <i class='ti-pinterest'></i>
            </a>
          </li> */}
        </ul>
      </div>
      <div class='post-content'>
        <div class='entry-meta meta-0 font-small mb-15'>
          <a>
            <span
              class='post-cat background1 color-white'
              style={{
                backgroundColor: item.background_color_category,
              }}
            >
              {item.name_category}
            </span>
          </a>
        </div>
        <h3 class='post-title'>
          <a
            href={`/${item.is_video_news === 1 ? 'tin-video' : 'tin-tuc'}/${
              item.slug
            }`}
          >
            {item.title}
          </a>
        </h3>
        <div class='entry-meta meta-1 font-small color-grey mt-15 mb-15'>
          <span class='post-on has-dot'>{item.created_at}</span>
          <span class='hit-count'>{/* <i class='ti-bolt'></i>  */}</span>
        </div>
        <div class='post-excerpt mb-25'>
          <p>{item.short_description}</p>
        </div>
      </div>
    </article>
  );
};
export default Article;
